import React from "react";
import { ResultPaginationLoadMoreProps } from "@usereactify/search";

export type ResultsPaginationLoadMoreProps = React.ComponentProps<
    NonNullable<ResultPaginationLoadMoreProps["render"]>
>;

export const ResultPaginationLoadMore: React.FC<ResultsPaginationLoadMoreProps> = (props) => {
    const { resultStats } = props;

    const collectionStartNumber = 1;
    const collectionEndNumber = resultStats?.numberOfResults || 0;
    const collectionCurrentLoadedNumber = resultStats?.displayedResults;

    const progressPercentage =
        ((collectionCurrentLoadedNumber - collectionStartNumber) /
            (collectionEndNumber - collectionStartNumber)) *
        100;

    return (
        <div className="collection-load-more__container flex flex-col align-center">
            <div className="collection-load-more__progress">
                <div className="collection-load-more__divider relative">
                    <p className="collection-load-more__count">
                        You've viewed{" "}
                        {collectionCurrentLoadedNumber === collectionEndNumber
                            ? "all "
                            : collectionCurrentLoadedNumber + " of "}
                        {collectionEndNumber} items
                    </p>
                </div>
                <div className="products-loaded__progress-bar">
                    <div
                        className="products-loaded__progress-bar-fill"
                        style={{
                            width: `${progressPercentage}%`,
                        }}
                    ></div>
                </div>
            </div>

            {collectionCurrentLoadedNumber !== collectionEndNumber && (
                <button
                    className="rs__pagination__loadmore-button button button-primary w-full"
                    onClick={() => props.handleLoadMore()}
                    disabled={!props.hasMore}
                >
                    {"Load more"}
                </button>
            )}
        </div>
    );
};
